const pageNameKey = "sourceInfoDrawerModal";

export const sourceInfoDrawerModalEn = {
  [pageNameKey]: {
    title: "Source Information",
    connectivity: "Connectivity",
    securityMode: "Security Mode",
    securityPolicy: "Security Policy",
  },
};

export const sourceInfoDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Informações do fonte",
    connectivity: "Conectividade",
    securityMode: "Modo de segurança",
    securityPolicy: "Política de Segurança",
  },
};

export const sourceInfoDrawerModalDe = {
  [pageNameKey]: {
    title: "Mit Source verbinden",
    connectivity: "Konnektivität",
    securityMode: "Sicherheitsmodus",
    securityPolicy: "Sicherheitsrichtlinie",
  },
};

export const sourceInfoDrawerModalZhHans = {
  [pageNameKey]: {
    title: "源信息",
    connectivity: "连接性",
    securityMode: "安全模式",
    securityPolicy: "安全策略",
  },
};

export const sourceInfoDrawerModalIt = {
  [pageNameKey]: {
    title: "Informazioni Macchina",
    connectivity: "Connettività",
    securityMode: "Modalità di sicurezza",
    securityPolicy: "Policy di sicurezza",
  },
};

export const sourceInfoDrawerModalEs = {
  [pageNameKey]: {
    title: "Información de origen",
    connectivity: "Conectividad",
    securityMode: "Modo de seguridad",
    securityPolicy: "Política de seguridad",
  },
};

export const sourceInfoDrawerModalNl = {
  [pageNameKey]: {
    connectivity: "Connectiviteit",
    securityMode: "Beveiligingsmodus",
    securityPolicy: "Beveiligingsbeleid",
    title: "Bron-informatie",
  },
};

export const sourceInfoDrawerModalTr = {
  [pageNameKey]: {
    connectivity: "Bağlantı",
    securityMode: "Güvenlik Modu",
    securityPolicy: "Güvenlik Politikası",
    title: "Kaynak Bilgileri",
  },
};
